import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import The247DigitalEngine from "./sections/The247DigitalEngine";
import OurDigitalArsenal from "./sections/OurDigitalArsenal";
import TheBlinklabAdvantage from "./sections/TheBlinklabAdvantage";
import Testimonials from "./sections/Testimonials";
import GrowthMetrics from "./sections/GrowthMetrics";
import IgniteYourGrowth from "./sections/IgniteYourGrowth";
import Ourworkportfolio from "./sections/Ourworkportfolio";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <The247DigitalEngine />
      <OurDigitalArsenal />
      <TheBlinklabAdvantage />
      <Testimonials />
      <GrowthMetrics />
      <IgniteYourGrowth />
      <Ourworkportfolio />
      <Footer />
    </div>;
}